import * as authTypes from 'modules/auth/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../actionTypes';

const initialState = false;

const isReady = () => true;

const clearState = () => initialState;

export default createReducer(initialState, {
  [types.APPLICATION_IS_READY]: isReady,
  [authTypes.SIGN_OUT_SUCCESS]: clearState,
  [authTypes.SIGN_OUT_EMERGENCY]: clearState,
});
